import * as cookieUtil from '@/utils/cookieUtil'
import customerService from '@/services/customer-service'

const customer = {
  state: {
    customerId: cookieUtil.get('customerId'),
    customerName: '',
    mobile: '',
    gender: '',
    birthday: '',
    age: '',
    mzCode: '',
    employeeName: ''
  },

  mutations: {
    SET_ID: (state, customerId) => {
      cookieUtil.set('customerId', customerId)
      state.customerId = customerId
    },
    SET_CUSTOMERNAME: (state, customerName) => {
      state.customerName = customerName
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile
    },
    SET_GENDER: (state, gender) => {
      state.gender = gender
    },
    SET_BIRTHDAY: (state, birthday) => {
      state.birthday = birthday
    },
    SET_AGE: (state, age) => {
      state.age = age
    },
    SET_MZCODE: (state, mzCode) => {
      state.mzCode = mzCode
    },
    SET_EMPLOYEENAME: (state, employeeName) => {
      state.employeeName = employeeName
    }
  },

  actions: {
    GetCustomerInfo ({commit, state}) {
      return new Promise((rseolve, reject) => {
        customerService.getCustomerInfo().then((res) => {
          if (res.statusCode == 200) {
            commit('SET_ID', res.data.id)
            commit('SET_CUSTOMERNAME', res.data.customerName)
            commit('SET_GENDER', res.data.gender)
            commit('SET_AGE', res.data.age)
            commit('SET_MZCODE', res.data.mzCode)
            commit('SET_EMPLOYEENAME', res.data.employeeName)
          }
          rseolve(res)
        }).catch((err) => {
          reject(error)
        })
      })
    }
  }
}

export default customer



// WEBPACK FOOTER //
// ./src/store/modules/customer.js